module.exports = __webpack_public_path__ + "src/app/venue/parkMap/assets/welcome.png?1acdea0ae550cffbf246b873838b5bda";